 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		37: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		37: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"f48f9fc4f0af6c25a8dcc13052d0a5f42129bf84","1":"styles","2":"13beb666fb9e2e20c2d99b88385fed0d7cc13c80","3":"ccb235419b02cc18cccc9d20a110c3a0337ed0a9","4":"c569a6d9f36332513d867ce67262fee594c57406","5":"28e75987652209cd2f60e9264440fd3751c72c2d","6":"446643f5cf0d4af6d6d721303972b00a0dc54e29","7":"3e08f4cd4bb30e8b82177eb4c26065ab13d5d7b2","8":"502bbb4237a07b052267798025cee2753d160ce0","9":"03a9ce3f4c4326b99416597a5754ab285ff7393e","10":"2d022c028fd83e50778a4cb85436956947e041de","11":"2f993c407bcbd7f477ab05ec861b7db8f29749e6","12":"6bc92a7c1de7f49f2070f0ac4a2758a2f6170ae1","13":"f4bbd15cca45c179949e40fcc9056d9d567db563","14":"29107295","15":"2dbb4e4c0007ff806b9d199ce92c1d1f1a069bef","16":"58efee62ea6b6779e1d059c102d915c001f0e4e7","17":"9e28ce214728a3784e9547e613bb4d9e5c0168d4","18":"50156b21f8f23d46105ca3e49abeecc3e76c8d28","19":"120186a5974b3ef5bb4882fd2758f01b46a81a72","20":"088fa04dc2c617c0b05922920cde263cb081f678","21":"38c2b2ec0e077ba3c769e6e402fda4185bb5c84c","22":"90a0999d7ab643b8891036d4dbe98bcb5d399005","23":"d3048c20","24":"2efe08a23b0d73a9a0bb9afe5bfb3ff56bc408d4","25":"39f89ff07727875c162415e24097db9ae3a618f5","26":"1a25870022f7d325f5068b4984babf060da548ac","27":"4322cd96","28":"640a8e0bed0c9893b028348def1195e0cc0c41f5","29":"75fdcd7ad95120ccc60c2fd614350a731ddb597b","30":"9baafa021ab19aee63f1c6de87820e4129a5848a","31":"9fbd84309127eff1e97d16c341312908e7601922","32":"dff27125","33":"f10e284a","34":"5a3fc9bea93cbb237fbc4747cdbac57ba850a9e9","35":"c598c9b4aaec2b92ccba9f27e171b4e2129b77f5","36":"component---src-templates-product-index-js","38":"725b77c5","40":"component---src-bulk-templates-bulk-product-index-js","41":"component---src-bulk-templates-bulk-product-list-index-js","42":"component---src-bulk-templates-dashboard-bulk-order-list-page-js","43":"component---src-bulk-templates-dashboard-index-js","44":"component---src-pages-404-js","45":"component---src-templates-about-index-js","46":"component---src-templates-checkout-cart-page-js","47":"component---src-templates-dashboard-article-editor-page-js","48":"component---src-templates-dashboard-categories-page-js","49":"component---src-templates-dashboard-config-ec-page-js","50":"component---src-templates-dashboard-contact-us-forms-page-js","51":"component---src-templates-dashboard-coupon-page-index-js","52":"component---src-templates-dashboard-foretastes-page-js","53":"component---src-templates-dashboard-index-js","54":"component---src-templates-dashboard-login-index-js","55":"component---src-templates-dashboard-members-page-js","56":"component---src-templates-dashboard-news-page-js","57":"component---src-templates-dashboard-orders-page-js","58":"component---src-templates-dashboard-products-page-js","59":"component---src-templates-dashboard-settings-page-js","60":"component---src-templates-dashboard-staffs-page-js","61":"component---src-templates-dashboard-stock-preview-page-js","62":"component---src-templates-dashboard-test-js","63":"component---src-templates-faq-index-js","64":"component---src-templates-foretaste-index-js","65":"component---src-templates-landing-index-js","66":"component---src-templates-news-index-js","67":"component---src-templates-news-list-index-js","68":"component---src-templates-order-index-js","69":"component---src-templates-order-list-index-js","70":"component---src-templates-product-list-index-js","71":"component---src-templates-product-product-preview-page-js","72":"component---src-templates-profile-index-js","73":"component---src-templates-register-index-js"}[chunkId]||chunkId) + "-" + {"0":"288faaeaffe02a050101","1":"e9d24b1846c7d6eb9685","2":"c38cb656ee517498af66","3":"0c577f38058704dbbfc3","4":"7fc54b0a2f85b4cb0765","5":"93786a55657030677724","6":"95784c440937b0350266","7":"08a2c0cd9e7c30edac03","8":"4be68fb375a4d3930573","9":"7feb196843218dc18c6f","10":"dc0665a4e823af7ce2d0","11":"2ae4235a22f3519e61a8","12":"37e7bc83f10652187a28","13":"4d733f34fc7a6e04f6ec","14":"e1fbbd8ecd7ee26aa6ad","15":"d9004937c1e063d5bcdb","16":"bca023e6b26a95f61a25","17":"72c3ee877bda805fa18b","18":"9dd4e3c568308831c7d5","19":"85628b79f3705c6d9ced","20":"53b269bce41f29ce0eb7","21":"13853267fb6053bef4b0","22":"6bdaf927f0926e99db2e","23":"b84fc508c07e523bb012","24":"19418868c38ec51eb8ac","25":"be3852577c1601cfb8ca","26":"71e5cf890455a3e66784","27":"bcbd71ce76b223cc0d56","28":"2e633f0b2a5d1542dd90","29":"8a951bc013c37be4602a","30":"1eaf007202f65ef9d193","31":"42ba128809072c506a41","32":"2b26cb13e485c6e767f5","33":"702171ce805283c08342","34":"d9dc6ff88271caed65d1","35":"c5499a033cc1c51ebe9c","36":"10cc937a3a53709f394d","38":"28e4f6eebf2b936a446c","40":"14003b72a2e891da3da3","41":"696e093a6ce7db4e11ae","42":"ce2eb4b4e4832f4dd1fa","43":"d2870dea8a63a9a2a85b","44":"acefea4da4bcbfad9458","45":"fee4df3e061a27feec5e","46":"b2c934a3e7495f763087","47":"2db131032650c5551b42","48":"ed5134a6544db9497034","49":"e09c3605f904aa232912","50":"8e21f3d772d776fdf4f3","51":"7a542437a67510a127c0","52":"0bb1381a17063aa0f85d","53":"fb97c18f6cc3fdc3c083","54":"1280ffa353f5d93e0f6e","55":"346b4d81bc676803c8da","56":"63c6810da8c5e1cd86cd","57":"f0e7b15cf309fac5fe76","58":"23b4d7c2ea4105f554ab","59":"6b191616dcac81eca864","60":"2b9cff1b875cc7d625b5","61":"4522b035c13206d21c86","62":"076c65185441da66f9ab","63":"b1c1f08a05afd8795222","64":"637617b655b8299410bf","65":"4738341defe79e79720c","66":"9a9b15ded318426fe15b","67":"f171049e70582afde631","68":"8feec4af5bfcf383c642","69":"4959910ddc2e18ab971f","70":"0334e2941bbcdb683ff7","71":"d983d3ea447651447037","72":"0124a6c3acdd9f653ebb","73":"1a2dfd7dc0ce43d09f1a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"f48f9fc4f0af6c25a8dcc13052d0a5f42129bf84","1":"styles","2":"13beb666fb9e2e20c2d99b88385fed0d7cc13c80","3":"ccb235419b02cc18cccc9d20a110c3a0337ed0a9","4":"c569a6d9f36332513d867ce67262fee594c57406","5":"28e75987652209cd2f60e9264440fd3751c72c2d","6":"446643f5cf0d4af6d6d721303972b00a0dc54e29","7":"3e08f4cd4bb30e8b82177eb4c26065ab13d5d7b2","8":"502bbb4237a07b052267798025cee2753d160ce0","9":"03a9ce3f4c4326b99416597a5754ab285ff7393e","10":"2d022c028fd83e50778a4cb85436956947e041de","11":"2f993c407bcbd7f477ab05ec861b7db8f29749e6","12":"6bc92a7c1de7f49f2070f0ac4a2758a2f6170ae1","13":"f4bbd15cca45c179949e40fcc9056d9d567db563","14":"29107295","15":"2dbb4e4c0007ff806b9d199ce92c1d1f1a069bef","16":"58efee62ea6b6779e1d059c102d915c001f0e4e7","17":"9e28ce214728a3784e9547e613bb4d9e5c0168d4","18":"50156b21f8f23d46105ca3e49abeecc3e76c8d28","19":"120186a5974b3ef5bb4882fd2758f01b46a81a72","20":"088fa04dc2c617c0b05922920cde263cb081f678","21":"38c2b2ec0e077ba3c769e6e402fda4185bb5c84c","22":"90a0999d7ab643b8891036d4dbe98bcb5d399005","23":"d3048c20","24":"2efe08a23b0d73a9a0bb9afe5bfb3ff56bc408d4","25":"39f89ff07727875c162415e24097db9ae3a618f5","26":"1a25870022f7d325f5068b4984babf060da548ac","27":"4322cd96","28":"640a8e0bed0c9893b028348def1195e0cc0c41f5","29":"75fdcd7ad95120ccc60c2fd614350a731ddb597b","30":"9baafa021ab19aee63f1c6de87820e4129a5848a","31":"9fbd84309127eff1e97d16c341312908e7601922","32":"dff27125","33":"f10e284a","34":"5a3fc9bea93cbb237fbc4747cdbac57ba850a9e9","35":"c598c9b4aaec2b92ccba9f27e171b4e2129b77f5","36":"component---src-templates-product-index-js","38":"725b77c5","40":"component---src-bulk-templates-bulk-product-index-js","41":"component---src-bulk-templates-bulk-product-list-index-js","42":"component---src-bulk-templates-dashboard-bulk-order-list-page-js","43":"component---src-bulk-templates-dashboard-index-js","44":"component---src-pages-404-js","45":"component---src-templates-about-index-js","46":"component---src-templates-checkout-cart-page-js","47":"component---src-templates-dashboard-article-editor-page-js","48":"component---src-templates-dashboard-categories-page-js","49":"component---src-templates-dashboard-config-ec-page-js","50":"component---src-templates-dashboard-contact-us-forms-page-js","51":"component---src-templates-dashboard-coupon-page-index-js","52":"component---src-templates-dashboard-foretastes-page-js","53":"component---src-templates-dashboard-index-js","54":"component---src-templates-dashboard-login-index-js","55":"component---src-templates-dashboard-members-page-js","56":"component---src-templates-dashboard-news-page-js","57":"component---src-templates-dashboard-orders-page-js","58":"component---src-templates-dashboard-products-page-js","59":"component---src-templates-dashboard-settings-page-js","60":"component---src-templates-dashboard-staffs-page-js","61":"component---src-templates-dashboard-stock-preview-page-js","62":"component---src-templates-dashboard-test-js","63":"component---src-templates-faq-index-js","64":"component---src-templates-foretaste-index-js","65":"component---src-templates-landing-index-js","66":"component---src-templates-news-index-js","67":"component---src-templates-news-list-index-js","68":"component---src-templates-order-index-js","69":"component---src-templates-order-list-index-js","70":"component---src-templates-product-list-index-js","71":"component---src-templates-product-product-preview-page-js","72":"component---src-templates-profile-index-js","73":"component---src-templates-register-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"84ad82039f7c3e672772","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
